// import Client from 'shopify-buy';

let samples = [];

// GET SAMPLES FROM COOKIE
if (Cookies.get("samples")) {
    console.log("Samples found in cookie");
    samples = JSON.parse(Cookies.get("samples"));
    samples.forEach((sample, index) => {
        addSampleToDrawer(index, sample.image, sample.title, sample.sku);
    });

    checkSamplePackComplete();
}

$("#btn_add_sample").on("click", function () {
    // GET PRODUCT ID
    var handle = $(this).attr("data-product-handle");

    // GET PRODUCT INFO
    $.ajax({
        type: "GET",
        url: "/products/" + handle + ".js",
        dataType: "json",
        success: function (response) {
            addSample(response);
        },
    });
});

function addSample(product) {
    if (samples.length === 3) {
        showErrorMessage("Je proefpakketje zit al vol! Verwijder een staaltje om een nieuw staaltje toe te voegen.");
        openSampleDrawer();
        return;
    } else if (samples.find((sample) => sample.id === product.id)) {
        showErrorMessage("Dit staaltje zit al in je proefpakketje!");
        openSampleDrawer();
        return;
    } else if (product.variants.length < 2) {
        showErrorMessage("Voor dit product kan geen staaltje aangevraagd worden.");
        return;
    }

    // SHOW SAMPLE POPUP
    if (!$("#sample-drawer").hasClass("show")) {
        openSampleDrawer();
    }

    samples.push({
        id: product.id,
        variant: product.variants[1].id,
        title: product.title,
        image: product.images[0],
        handle: product.handle,
        url: product.url,
        price: product.price,
        sku: product.variants[0].sku,
    });

    hideErrorMessage();

    checkSamplePackComplete();
    addSampleToDrawer(samples.length - 1, product.images[0], product.title, product.variants[0].sku);

    // ADD SAMPLE TO COOKIE
    Cookies.set("samples", JSON.stringify(samples), { expires: 7 });
}

function checkSamplePackComplete() {
    if (samples.length > 0) {
        $("#btn_checkout_samples").addClass("active");
        $("#btn_checkout_samples").attr("disabled", false);
    } else {
        $("#btn_checkout_samples").removeClass("active");
        $("#btn_checkout_samples").attr("disabled", true);
    }
}

function showErrorMessage(message) {
    $("#btn_add_sample .error p").html(message);
    $("#btn_add_sample .error").show();
}
function hideErrorMessage() {
    $("#btn_add_sample .error").hide();
}

function addSampleToDrawer(index, image, title, sku) {
    $("#sample-drawer .sample-drawer__image").eq(index).attr("src", image);
    $("#sample-drawer .sample-drawer__image").eq(index).show();
    $("#sample-drawer .sample-drawer__sample-title").eq(index).html(title);
    $("#sample-drawer .sample-drawer__sample-title").eq(index).show();
    $("#sample-drawer .sample-drawer__sample-sku").eq(index).html(sku);
    $("#sample-drawer .sample-drawer__sample-sku").eq(index).show();
    $("#sample-drawer .sample-drawer__sample").eq(index).addClass("occupied");
}
function removeSampleFromDrawer(index) {
    if (samples[index] === undefined) return;
    $("#sample-drawer .sample-drawer__image").attr("src", "");
    $("#sample-drawer .sample-drawer__image").hide();
    $("#sample-drawer .sample-drawer__sample-title").eq(index).html("");
    $("#sample-drawer .sample-drawer__sample-title").hide();
    $("#sample-drawer .sample-drawer__sample-sku").eq(index).html("");
    $("#sample-drawer .sample-drawer__sample-sku").hide();
    $("#sample-drawer .sample-drawer__sample").removeClass("occupied");
    samples.splice(index, 1);
    Cookies.set("samples", JSON.stringify(samples), { expires: 7 });

    // REINDEX DRAWER SAMPLES
    samples.forEach((sample, index) => {
        addSampleToDrawer(index, sample.image, sample.title, sample.sku);
    });
}

// CLOSING SAMPLE DRAWER
$("#sample-drawer .sample-drawer__close").on("click", function () {
    closeSampleDrawer();
});

$(".small-promo, #sample-footer-btn").on("click", function () {
    if (!$("#sample-drawer").hasClass("show")) {
        openSampleDrawer();
    } else {
        closeSampleDrawer();
    }
});

// on click outside drawer
$(document).on("mousedown", function (e) {
    var container = $("#sample-drawer, #btn_add_sample, .small-promo");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
        closeSampleDrawer();
    }
});

function closeSampleDrawer() {
    $("#sample-drawer").removeClass("show");
}
function openSampleDrawer() {
    $("#sample-drawer").addClass("show");
}
// END CLOSING SAMPLE DRAWER

$("#btn_checkout_samples").on("click", function () {
    // TODO GET SAMPLES FROM COOKIE
    addSamplesToCart(samples, $(this));
});
$(".sample-drawer__sample__remove").on("click", function () {
    removeSampleFromDrawer($(".sample-drawer__sample__remove").index(this));
});

$("#sample-drawer").on("click", ".sample-drawer__sampler.occupied", function () {
    window.location.replace("/products/" + samples[$(".sample-drawer__sample.occupied").index(this)].handle);
});

// add samples to cart
async function addSamplesToCart(samples, button) {
    if (samples.length < 1) {
        $(".sample-drawer__sample").addClass("shake");
        setTimeout(() => {
            $(".sample-drawer__sample").removeClass("shake");
        }, 5000);
        return;
    }

    button.html('<i class="fas fa-spinner fa-spin"></i>');
    button.attr("disabled", true);

    let items = [];
    samples.forEach((sample) => {
        items.push({
            variantId: "gid://shopify/ProductVariant/" + sample.variant,
            quantity: 1,
        });
    });

    items.forEach((item) => {
        console.log("item", item);
    });

    const sampleLines = samples.map((sample) => ({
        merchandiseId: `gid://shopify/ProductVariant/${sample.variant}`,
        quantity: 1,
    }));

    //* Make a storefront api gql request to create a cart, and get a checkout url
    try {
        await fetch("https://vloerenmarkt-nl.myshopify.com/api/2025-01/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": "67b5fd875930b339672137b905fcdacd",
            },
            body: JSON.stringify({
                query: `
            mutation cartCreate($input: CartInput) {
                cartCreate(input: $input) {
                    cart {
                        id
                        checkoutUrl
                    }
                    userErrors {
                        field
                        message
                    }
                }
            }`,
                variables: JSON.stringify({
                    input: {
                        lines: sampleLines,
                    },
                }),
            }),
        })
            .then((response) => {
                if (response.status != 200) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((res) => {
                if (res.data.cartCreate.userErrors.length > 0) {
                    console.error("Error creating cart:", res.data.cartCreate.userErrors);
                    return;
                }

                // Redirect to checkout
                const checkoutUrl = res.data.cartCreate.cart.checkoutUrl;
                window.location.href = checkoutUrl;
            });
    } catch (error) {
        console.error("Error creating cart:", error);
    } finally {
        button.html("Staaltjes bestellen");
        button.attr("disabled", false);
    }
}
